import { useContext, useCallback } from "react";
import WidgetContext from "views/components/contexts/WidgetContext";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
const useSendFavoriteFieldTelemetry = () => {
  var _a;
  const widget = useContext(WidgetContext);
  const widgetType = (_a = widget == null ? void 0 : widget.type) != null ? _a : "permalink";
  const sendTelemetry = useSendTelemetry(widgetType);
  return useCallback(
    (key, extra = {}) => {
      var _a2;
      return sendTelemetry((_a2 = TELEMETRY_EVENT_TYPE.FAVORITE_FIELDS) == null ? void 0 : _a2[key], extra);
    },
    [sendTelemetry]
  );
};
export default useSendFavoriteFieldTelemetry;
